<div *ngIf="isLoading" class="stitch-loader-container">
  <div class="stitch-spinner"></div>
  <p class="stitch-loader-text">Cargando catálogo exclusivo...</p>
</div>

<div *ngIf="!isLoading" class="stitch-shop-wrapper">
  <!-- Hero Banner Stitch -->
  <div class="stitch-shop-hero">
    <div class="hero-overlay"></div>
    <div class="hero-content text-center">
      <h1 class="hero-title">Catálogo de Productos</h1>

      <!-- Buscador Principal Stitch -->
      <div class="stitch-search-box">
        <i class="fas fa-search search-icon"></i>
        <input type="text" class="stitch-search-input"
          placeholder="Buscar por nombre, marca, categoría (ej. Tenis, iPhone, Vestidos)..." [(ngModel)]="searchTerm"
          (input)="applyFilters()" />
        <button *ngIf="searchTerm" class="search-clear-btn" (click)="removeFilter('searchTerm')">
          <i class="fas fa-times"></i>
        </button>
        <button class="search-submit-btn" (click)="applyFilters()">Buscar</button>
      </div>
    </div>
  </div>

  <div class="container-fluid px-lg-5 py-4">
    <!-- Toolbar de Control (Ordenamiento y Modos de Vista) -->
    <div class="stitch-toolbar d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
      <!-- Izquierda: Toggle Filtros & Contador -->
      <div class="d-flex align-items-center gap-3">
        <button class="stitch-btn-filter-toggle" (click)="toggleFilters()">
          <i class="fas fa-sliders-h me-2"></i>
          <span>{{ areFiltersVisible ? 'Ocultar Filtros' : 'Mostrar Filtros' }}</span>
          <span *ngIf="getActiveFiltersCount() > 0" class="badge-active-count">{{ getActiveFiltersCount() }}</span>
        </button>
        <span class="results-count">
          <strong>{{ filteredProducts.length }}</strong> {{ filteredProducts.length === 1 ? 'producto encontrado' :
          'productos encontrados' }}
        </span>
      </div>

      <!-- Derecha: Ordenamiento & Vista -->
      <div class="d-flex align-items-center gap-3 flex-wrap ms-auto">
        <div class="stitch-sort-group d-none d-md-flex align-items-center">
          <span class="sort-label">Ordenar:</span>
          <button class="sort-chip" [class.active]="sortOption === 'az'" (click)="setSort('az')">A - Z</button>
          <button class="sort-chip" [class.active]="sortOption === 'za'" (click)="setSort('za')">Z - A</button>
          <button class="sort-chip" [class.active]="sortOption === 'low-high'" (click)="setSort('low-high')">Menor
            Precio</button>
          <button class="sort-chip" [class.active]="sortOption === 'high-low'" (click)="setSort('high-low')">Mayor
            Precio</button>
        </div>

        <div class="view-mode-selector d-none d-sm-flex align-items-center gap-1">
          <button class="view-btn" [class.active]="viewMode === 'grid'" (click)="viewMode = 'grid'; gridColumns = 4"
            title="Vista de cuadrícula">
            <i class="fas fa-th"></i>
          </button>
          <button class="view-btn" [class.active]="viewMode === 'list'" (click)="viewMode = 'list'"
            title="Vista de lista">
            <i class="fas fa-list"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Chips de Filtros Activos -->
    <div *ngIf="getActiveFiltersCount() > 0" class="stitch-active-chips d-flex flex-wrap align-items-center gap-2 mb-4">
      <span class="active-chips-label"><i class="fas fa-filter me-1"></i> Filtros aplicados:</span>

      <span *ngIf="searchTerm" class="active-chip">
        Búsqueda: "{{ searchTerm }}"
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('searchTerm')"></i>
      </span>
      <span *ngIf="selectedCategory" class="active-chip">
        Categoría: {{ selectedCategory }}
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('category')"></i>
      </span>
      <span *ngIf="selectedBrand" class="active-chip">
        Marca: {{ selectedBrand }}
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('brand')"></i>
      </span>
      <span *ngIf="selectedGender" class="active-chip">
        Género: {{ selectedGender }}
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('gender')"></i>
      </span>
      <span *ngIf="selectedColor" class="active-chip">
        Color: {{ selectedColor }}
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('color')"></i>
      </span>
      <span *ngIf="selectedSize" class="active-chip">
        Talla: {{ selectedSize }}
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('size')"></i>
      </span>
      <span *ngIf="onlyInStock" class="active-chip">
        Solo disponible
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('stock')"></i>
      </span>
      <span *ngIf="selectedMinPrice > minPrice || selectedMaxPrice < maxPrice" class="active-chip">
        Precio: ${{ selectedMinPrice | number }} - ${{ selectedMaxPrice | number }}
        <i class="fas fa-times ms-2 cursor-pointer" (click)="removeFilter('price')"></i>
      </span>

      <button class="btn-clear-all-chips" (click)="resetFilters()">
        Limpiar todos
      </button>
    </div>

    <!-- Main Layout (Sidebar + Products Grid) -->
    <div class="row">
      <!-- Sidebar de Filtros Glassmorphic -->
      <div class="col-lg-3 col-md-4 filters-sidebar-column" [class.d-none]="!areFiltersVisible">
        <div class="stitch-filter-card shadow-sm">
          <div class="filter-card-header d-flex justify-content-between align-items-center">
            <h5 class="filter-title mb-0"><i class="fas fa-filter me-2"></i>Filtros Avanzados</h5>
            <button class="btn-reset-text" (click)="resetFilters()" title="Restablecer filtros">
              Reset
            </button>
          </div>

          <div class="filter-card-body">
            <!-- 1. Categoría -->
            <div class="filter-group mb-4" *ngIf="categories.length > 0">
              <label class="filter-label">Categoría</label>
              <select class="stitch-select" [(ngModel)]="selectedCategory" (change)="applyFilters()">
                <option value="">Todas las categorías</option>
                <option *ngFor="let cat of categories" [value]="cat">{{ cat }}</option>
              </select>
            </div>

            <!-- 2. Marca -->
            <div class="filter-group mb-4" *ngIf="brands.length > 0">
              <label class="filter-label">Marca</label>
              <select class="stitch-select" [(ngModel)]="selectedBrand" (change)="applyFilters()">
                <option value="">Todas las marcas</option>
                <option *ngFor="let brand of brands" [value]="brand">{{ brand }}</option>
              </select>
            </div>

            <!-- 3. Género -->
            <div class="filter-group mb-4" *ngIf="genders.length > 0">
              <label class="filter-label">Género / Público</label>
              <select class="stitch-select" [(ngModel)]="selectedGender" (change)="applyFilters()">
                <option value="">Todos los géneros</option>
                <option *ngFor="let gender of genders" [value]="gender">{{ gender }}</option>
              </select>
            </div>

            <!-- 4. Color -->
            <div class="filter-group mb-4" *ngIf="colors.length > 0">
              <label class="filter-label">Color</label>
              <div class="color-chips-grid">
                <button class="color-chip-item color-chip-all" [class.selected]="selectedColor === ''"
                  (click)="selectedColor = ''; applyFilters()" title="Todos los colores">
                  Todos
                </button>
                <button *ngFor="let c of colors" class="color-chip-item" [class.selected]="selectedColor === c"
                  (click)="selectedColor = (selectedColor === c ? '' : c); applyFilters()" [ngStyle]="getColorStyle(c)"
                  [title]="c">
                  <i *ngIf="selectedColor === c" class="fas fa-check"></i>
                </button>
              </div>
            </div>

            <!-- 5. Talla -->
            <div class="filter-group mb-4" *ngIf="sizes.length > 0">
              <label class="filter-label">Talla</label>
              <div class="size-chips-grid">
                <button *ngFor="let size of sizes" class="size-chip-btn" [class.selected]="selectedSize === size"
                  (click)="selectedSize = (selectedSize === size ? '' : size); applyFilters()">
                  {{ size }}
                </button>
              </div>
            </div>

            <!-- 6. Disponibilidad de Stock -->
            <div class="filter-group mb-4">
              <label class="stitch-checkbox-container">
                <input type="checkbox" [(ngModel)]="onlyInStock" (change)="applyFilters()" />
                <span class="checkmark"></span>
                <span class="checkbox-label">Solo productos en Stock</span>
              </label>
            </div>

            <!-- 7. Dual Range Slider de Precios -->
            <div class="filter-group mb-2">
              <label class="filter-label">Rango de Precio (COP)</label>
              <div class="price-display-badges d-flex justify-content-between mb-2">
                <span class="price-badge">${{ selectedMinPrice | number }}</span>
                <span class="price-badge">${{ selectedMaxPrice | number }}</span>
              </div>
              <div class="stitch-range-slider">
                <input type="range" [min]="minPrice" [max]="maxPrice" [(ngModel)]="selectedMinPrice"
                  (input)="onMinPriceChange()" />
                <input type="range" [min]="minPrice" [max]="maxPrice" [(ngModel)]="selectedMaxPrice"
                  (input)="onMaxPriceChange()" />
                <div class="slider-track-fill"
                  [style.left.%]="((selectedMinPrice - minPrice) / ((maxPrice - minPrice) || 1)) * 100"
                  [style.right.%]="100 - (((selectedMaxPrice - minPrice) / ((maxPrice - minPrice) || 1)) * 100)"></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Área de Productos -->
      <div [class]="areFiltersVisible ? 'col-lg-9 col-md-8' : 'col-12'">
        <!-- Sin resultados -->
        <div *ngIf="filteredProducts.length === 0" class="stitch-empty-results text-center py-5">
          <div class="empty-icon-wrapper mb-3">
            <i class="fas fa-search-minus fa-3x text-muted"></i>
          </div>
          <h4 class="empty-title">No encontramos productos que coincidan</h4>
          <p class="empty-desc text-muted">Intenta cambiar los filtros seleccionados o realiza una búsqueda más amplia.
          </p>
          <button class="stitch-btn-primary mt-2" (click)="resetFilters()">
            <i class="fas fa-redo me-2"></i>Limpiar todos los filtros
          </button>
        </div>

        <!-- Vista Grilla -->
        <div *ngIf="viewMode === 'grid'" class="row g-4">
          <div *ngFor="let product of filteredProducts" class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
            <div class="stitch-product-card h-100">
              <!-- Top Badges Image Container -->
              <div class="product-img-wrapper">
                <span class="badge-out-of-stock" *ngIf="isOutOfStock(product)">
                  <i class="fas fa-times-circle me-1"></i>Agotado
                </span>
                <span class="badge-discount" *ngIf="!isOutOfStock(product) && (product.discountPercentage || product.hasDiscount)">
                  -{{ product.discountPercentage || 20 }}% DCTO
                </span>
                <span class="badge-shipping" *ngIf="!isOutOfStock(product) && (product.isFreeShipping || product.price > 150000)">
                  <i class="fas fa-truck me-1"></i>Envío Gratis
                </span>
                <img [src]="resolveImg(product.image || product.imageUrl)" class="product-main-img" [alt]="product.name"
                  (error)="onImageError($event)" />
                <div class="card-overlay-actions">
                  <button class="btn-quick-view" (click)="openProductModal(product)" title="Vista Rápida">
                    <i class="fas fa-eye me-1"></i> Vista Rápida
                  </button>
                </div>
              </div>

              <!-- Product Info -->
              <div class="product-card-body d-flex flex-column">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <span class="product-category-tag">{{ product.category || 'Destacado' }}</span>
                  <span *ngIf="product.brand" class="product-brand-tag">{{ product.brand }}</span>
                </div>

                <h5 class="product-title" (click)="openProductModal(product)">{{ product.name }}</h5>
                <p class="product-description">{{ product.description }}</p>

                <div class="product-footer mt-auto pt-3 border-top d-flex align-items-center justify-content-between">
                  <div class="price-container">
                    <span class="current-price">${{ product.price | number }} COP</span>
                    <span *ngIf="product.originalPrice" class="original-price">${{ product.originalPrice | number
                      }}</span>
                  </div>

                  <button class="btn-stitch-cart" (click)="openProductModal(product)" title="Seleccionar y comprar">
                    <i class="fas fa-shopping-bag"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vista Lista -->
        <div *ngIf="viewMode === 'list'" class="list-view-container d-flex flex-column gap-3">
          <div *ngFor="let product of filteredProducts"
            class="stitch-product-card-list d-flex flex-column flex-md-row p-3 shadow-sm border rounded align-items-center gap-4">
            <div class="list-img-wrapper">
              <img [src]="resolveImg(product.image || product.imageUrl)" [alt]="product.name"
                (error)="onImageError($event)" />
            </div>
            <div class="list-content-wrapper flex-grow-1">
              <div class="d-flex gap-2 align-items-center mb-1">
                <span class="product-category-tag">{{ product.category }}</span>
                <span *ngIf="product.brand" class="product-brand-tag">{{ product.brand }}</span>
              </div>
              <h4 class="product-title" (click)="openProductModal(product)">{{ product.name }}</h4>
              <p class="product-description line-clamp-3">{{ product.description }}</p>
            </div>
            <div class="list-price-wrapper text-md-end d-flex flex-column align-items-md-end justify-content-center">
              <span class="current-price display-6 fw-bold text-primary">${{ product.price | number }} COP</span>
              <span *ngIf="!isOutOfStock(product)" class="text-success small mb-3"><i class="fas fa-check-circle me-1"></i>Despacho Inmediato</span>
              <span *ngIf="isOutOfStock(product)" class="text-danger small mb-3 fw-bold"><i class="fas fa-times-circle me-1"></i>Agotado Temporalmente</span>

              <button class="btn-stitch-list-action" [class.btn-out-of-stock]="isOutOfStock(product)" (click)="openProductModal(product)">
                <i class="fas" [ngClass]="isOutOfStock(product) ? 'fa-eye' : 'fa-shopping-cart'"></i>
                <span>{{ isOutOfStock(product) ? 'Ver Producto' : 'Ver Opciones' }}</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>